jQuery(function ($) {
    let loadmoreBtn = $('#solutions-loadmore');
    let solutionsArticles = $('#solutions-articles');
    let postsPerLoad = loadmoreBtn.data('posts-per-load');
    let paged = loadmoreBtn.data('paged');
    let maxPaged = loadmoreBtn.data('max-pages');
    let ajaxUrl = `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}/wp-admin/admin-ajax.php`;
    let currentTerm = loadmoreBtn.data('current-term');
    loadmoreBtn.click(function () {
        paged++;
        loadmoreBtn.addClass('loading-start').attr('disabled', 'disabled');

        let data = {
            'action': 'ajax_solutions_posts',
            'post-per-load': postsPerLoad,
            'paged': paged
        }

        if (currentTerm) {
            data['current-term'] = currentTerm;
        }

        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data,
            success: function (data) {
                solutionsArticles.append(data)
                if (paged >= maxPaged) {
                    loadmoreBtn.hide();
                }
                loadmoreBtn.removeClass('loading-start').removeAttr('disabled');
            }
        });
    });
});